var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
        _vm._v("该工单是否确认放弃？"),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "内审人员", prop: "auditUser" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择内审人员",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.auditUser,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "auditUser", $$v)
                    },
                    expression: "form.auditUser",
                  },
                },
                _vm._l(_vm.nsOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "放弃类型", prop: "abandonTypeId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择放弃类型",
                    clearable: "",
                    filterable: "",
                  },
                  on: { change: _vm.showReason },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.clearQuitReason.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.form.abandonTypeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "abandonTypeId", $$v)
                    },
                    expression: "form.abandonTypeId",
                  },
                },
                _vm._l(_vm.quitOptions, function (item) {
                  return _c("el-option", {
                    key: item.seqId,
                    attrs: { label: item.content, value: item.seqId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "放弃原因", prop: "abandonCommentId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择放弃原因",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.abandonCommentId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "abandonCommentId", $$v)
                    },
                    expression: "form.abandonCommentId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.seqId,
                    attrs: { label: item.content, value: item.seqId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "小记", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入小记",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.note,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "note",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v(" 确 定 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }